
























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import TagItem from "@/components/TagItem";

@Component({ name: "SelectTagsView", components: { TagItem, BasePage, BaseButton, BaseSpinner, CustomScroll } })
export default class SelectTagsView extends Vue {
  @Prop({ type: Array, default: () => [] })
  public readonly preSelectedTags!: string[];

  @Prop({ type: Array, required: true })
  public readonly tags!: TagInfo[];

  @Prop({ type: String, default: $t("Save") })
  public readonly saveButtonText!: string;

  @Prop({ type: Boolean, required: true })
  public readonly loading!: boolean;

  @Prop({ type: Number, default: 1 })
  public readonly minimumSelection!: number;

  @Prop({ type: Number, default: 5 })
  public readonly maxSelection!: number;

  public selectedTags: Record<string, boolean> = {};

  public saving: boolean = false;

  public get saveDisabled() {
    return this.getSelectedTags(this.checkedTags).length < this.minimumSelection;
  }

  public get preSelectedTagsMap() {
    return this.preSelectedTags.reduce<Record<string, boolean>>((out, item) => {
      out[item] = true;
      return out;
    }, {});
  }

  public get checkedTags() {
    return this.tags.reduce<Record<string, boolean>>((out, item) => {
      out[item.id] = this.selectedTags[item.id] ?? this.preSelectedTagsMap[item.id] ?? false;
      return out;
    }, {});
  }

  @Watch("preSelectedTags")
  public watchPreselectedTags() {
    this.selectedTags = {};
  }

  public getSelectedTags(tags: Record<string, boolean>): string[] {
    let selectedTags: string[] = [];
    for (const tagId in tags) {
      if (tags[tagId]) selectedTags.push(tagId);
    }
    return selectedTags;
  }

  public selectTag(tag: TagInfo, value: boolean) {
    if (this.getSelectedTags(this.checkedTags).length >= this.maxSelection && value) return;
    this.$set(this.selectedTags, tag.id, value);
    this.$emit("input", this.getSelectedTags(this.checkedTags));
  }

  public save() {
    this.saving = true;
    this.$emit("save", this.getSelectedTags(this.checkedTags), () => (this.saving = false));
  }
}
